export enum EDownloadStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  PREPARING = 'preparing',
  DOWNLOADING = 'downloading',
}
